const EARTH_VIDEO = "/prototype/earth-boomerang.mp4";
const EARTH_POSTER = "/prototype/earth-boomerang-poster.jpg";

export const EarthShowcase = () => (
  <div className="relative w-full aspect-video" data-testid="earth-showcase">
    <video
      src={EARTH_VIDEO}
      poster={EARTH_POSTER}
      muted
      playsInline
      autoPlay
      loop
      preload="auto"
      className="absolute inset-0 w-full h-full object-cover object-center"
    />
  </div>
);
